import { render, staticRenderFns } from "./Library.vue?vue&type=template&id=63bc4d7c&scoped=true"
import script from "./Library.vue?vue&type=script&lang=js"
export * from "./Library.vue?vue&type=script&lang=js"
import style0 from "./Library.vue?vue&type=style&index=0&id=63bc4d7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bc4d7c",
  null
  
)

export default component.exports